const VALID_ANLAGENSCHLUESSEL_REGEX = /^E[1-4](.{31})$/;

/**
 * Validates an EEG-Anlagenschlüssel.
 * Returns true if the value is valid, or an error message string if it is not.
 */
function validateEegAnlagenschluessel(value: string): string | true {
  if (value.length !== 33) {
    return "Der Anlagenschlüssel muss genau 33 Zeichen lang sein.";
  }

  if (value[0] !== "E") {
    return "Der Anlagenschlüssel muss mit einem 'E' beginnen.";
  }

  const isSecondCharNumber = /^\d$/.test(value[1]);
  if (!isSecondCharNumber || parseInt(value[1]) < 1 || parseInt(value[1]) > 4) {
    return "An zweiter Stelle muss eine Zahl zwischen 1 und 4 stehen.";
  }

  return (
    VALID_ANLAGENSCHLUESSEL_REGEX.test(value) ||
    "Bitte geben Sie einen gültigen Anlagenschlüssel ein."
  );
}

export { validateEegAnlagenschluessel };
